export default __webpack_public_path__ + "static/media/maillogo.2690e6e9.svg";